/**
 * theme-lightbox.js
 * Lightbox/Gallery functionality (Fancybox)
 * 
 * Size: ~60KB minified
 * Load: Asynchronous, non-blocking
 * Triggers: [data-fancybox], .wp-block-gallery, .gallery detected
 */

import { Fancybox } from "@fancyapps/ui";

// Prevent duplicate initialization
if (window.themeLightbox) {
  console.log('[Lightbox] Already loaded - skipping duplicate');
} else {
  console.log('[Lightbox] Loaded');

  /**
   * Initialize Fancybox
   */
  function initFancybox() {
    const hasTargets = document.querySelector('[data-fancybox]') || 
                      document.querySelector('.wp-block-gallery') ||
                      document.querySelector('.gallery');
    
    if (!hasTargets) {
      console.log('[Lightbox] No targets found');
      return;
    }

    console.log('[Lightbox] Initializing Fancybox');

    try {
      // Bind standard fancybox elements
      Fancybox.bind("[data-fancybox]", { 
        hideScrollbar: true,
        Toolbar: {
          display: {
            left: ["infobar"],
            middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY"],
            right: ["slideshow", "thumbs", "close"],
          },
        },
      });
            
      
      console.log('[Lightbox] Initialized successfully');
    } catch (error) {
      console.error('[Lightbox] Initialization error:', error);
    }
  }

  /**
   * Refresh Fancybox (for dynamic content)
   */
  function refreshFancybox() {
    console.log('[Lightbox] Refreshing...');
    Fancybox.destroy();
    initFancybox();
  }

  // Make globally available
  window.themeLightbox = {
    init: initFancybox,
    refresh: refreshFancybox,
    Fancybox,
  };

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFancybox);
  } else {
    initFancybox();
  }
}